// Top Left View Type
export enum ETopLeftViewType {
  LEFT = "left",
  FRONT = "front",
  RIGHT = "right",
  BACK = "back",
  SPLIT = "split",
}

export enum ESteupModelType {
  IPRN_SPACE_MANAGEMENT = "ipr_space_management",
  PONTIC_DOME = "pontic_dome",
  GLOBAL_MOVEMENT = "global_movement",
  ARCH_FORM = "arch_form",
}

export enum EIPRNtoNType {
  // 3表示3-3，4表示4-4，5表示5-5
  IPRNtoNType_3 = "3",
  IPRNtoNType_4 = "4",
  IPRNtoNType_5 = "5",
}

export enum EArchForm {
  FASTSMART = "fastsmart",
  FINETUNE = "finetune",
}

export enum EBiteJump {
  BEGINNING = "beginning",
  THROUGHOUT = "throughout",
  END = "end",
}

export enum EGMVec {
  LEFT = "left",
  RIGHT = "right",
}

export enum EGMButtonTypes {
  GROUP_1 = "group_1",
  GROUP_2 = "group_2",
  GROUP_3 = "group_3",
  GROUP_4 = "group_4",
  GROUP_5 = "group_5",
  GROUP_6 = "group_6",
}

export interface IGMListItem {
  type: EGMButtonTypes
  iconLeft: React.ReactNode
  iconRight: React.ReactNode
  value: string
  unit: string
}
